// import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter} from "react-router-dom";
import { useEffect, useState } from "react";
import Api from "./components/Api";
import axios from "axios";
import GlobalState from "../src/contexts/GlobalState";
import { ParallaxProvider } from 'react-scroll-parallax';
import AppRoutes from "./components/AppRoutes";

function App() {
  const [popup, setPopup] = useState(false);
  
  // const axiosBaseUrl = "http://127.0.0.1:8000/api/" + localStorage.getItem('language');
  // const axiosBaseUrl = "https://wherediditgo.org/api/" + localStorage.getItem('language');
  // const axiosBaseUrl = "https://lta.hellotree.dev/api/" + localStorage.getItem('language');
  const axiosBaseUrl = "https://lta-latest.hellotree.dev/api/" + localStorage.getItem('language');

  axios.defaults.baseURL = axiosBaseUrl;

  const [generalData, setGeneralData] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const [generalDataApiOptions, setGeneralDataApiOptions] = useState({});

  useEffect(() => {
    setGeneralDataApiOptions({
      url: "general",
      callback: (res) => {
        setGeneralData(res.data);
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'icon';
        link.href = res.data.general.favicon_path;

        document.getElementsByTagName('head')[0].appendChild(link);

        const appleTouchLink = document.querySelector("link[rel='apple-touch-icon']") || document.createElement('link');
        appleTouchLink.rel = 'apple-touch-icon';
        appleTouchLink.href = res.data.general.logo192_path;

        document.getElementsByTagName('head')[0].appendChild(appleTouchLink);

        document.body.style.color = res.data.general.text_color;
        const root = document.documentElement; // The :root element
        root.style.setProperty('--primary-text-color', res.data.general.text_color);
        root.style.setProperty('--primary-color', res.data.general.primary_color);
        root.style.setProperty('--secondary-color', res.data.general.secondary_color);
        root.style.setProperty('--faded-primary-color', res.data.general.secondary_color + "80");
      },
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps




  useEffect(() => {
    if (!sessionStorage.getItem("lta-first-visit")) {
      setPopup(true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Api options={generalDataApiOptions} />

      <GlobalState.Provider
        value={{
          generalDataGlobal: [generalData, setGeneralData],
          setPopup,
          popup,
          setIsOpen,
          isOpen
        }}
      >
        <ParallaxProvider>
          <BrowserRouter>
            <AppRoutes/>
          </BrowserRouter>
        </ParallaxProvider>
      </GlobalState.Provider>
    </>
  );
}

export default App;
